import { proxy } from "valtio";
import { CircleData } from "../types/wizard";

interface ColorWarningStore {
  isOpen: boolean;
  isEditing: boolean;
  colorToRemove: CircleData | null;
  onConfirmCallback: (() => void) | null;
  openModal: (color: CircleData, isEditing: boolean, callback: () => void) => void;
  closeModal: () => void;
}

export const colorWarningStore = proxy<ColorWarningStore>({
  isOpen: false,
  isEditing: false,
  colorToRemove: null,
  onConfirmCallback: null,
  openModal: (color, isEditing, callback) => {
    if (colorWarningStore.isOpen) return;

    colorWarningStore.colorToRemove = color;
    colorWarningStore.isEditing = isEditing;
    colorWarningStore.onConfirmCallback = callback;
    colorWarningStore.isOpen = true;
  },
  closeModal: () => {
    colorWarningStore.isOpen = false;
    colorWarningStore.colorToRemove = null;
    colorWarningStore.onConfirmCallback = null;
  },
});

